<template lang="pug">
  .progress-steps-wrapper
    .left-arrow
      .icon-ptt-icons-dropdown.fs-21.to-click(v-if="currentStep > 0", @mouseup="lastStep")
    .correcoes-title
      span correções
    .correcoes
      .odd-days
        span.circle.to-click(:class="stepColor(0)", @click="setStep('doubleLines')", :data-badge="totals.doubleLines") 2x
        span.fs-13 dias duplicados
      //- .line
      .incorrect-points
        span.circle.icon-ptt-icons-check.to-click(:class="stepColor(1)", @click="setStep('oddPts')", :data-badge="totals.oddPts")
        span.fs-13 pontos para corrigir

    .conferencias-title
      span conferências
    .conferencias
      .pendencies
        span.circle.icon-ptt-icons-pin.to-click(:class="stepColor(2)", @click="setStep('pendency')", :data-badge="totals.pendency")
        span.fs-13 notas
      .apontamentos
        span.circle.icon-ptt-icons-calendario.to-click(:class="stepColor(3)", @click="setStep('timemeasurement')")
        span.fs-13 apontamentos
      .events
        span.circle.icon-ptt-icons-estrela.to-click(:class="stepColor(4)", @click="setStep('events')")
        span.fs-13 eventos
    .right-arrow
      .icon-ptt-icons-dropdown.fs-21.to-click(v-if="currentStep < 4", @mouseup="nextStep")

</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    currentStep: { required: true, type: Number },
    steps: { required: true, type: Array },
    currentSubStep: { required: false, type: Number, 'default': null }
  },
  computed: {
    ...mapState('verifyTimesheet', ['totals'])
  },
  methods: {
    setStep (id) {
      this.$emit('change', id)
    },
    nextStep () {
      this.$emit('change', this.steps[this.currentStep + 1].id)
    },
    lastStep () {
      this.$emit('change', this.steps[this.currentStep - 1].id)
    },
    stepColor (number) {
      if (number === this.currentStep) {
        return ['selected-color']
      }
      return ['not-selected-color']
    }
  }
}
</script>

<style scoped lang="scss">
.progress-steps-wrapper {
  width: 100%;
  display: grid;
  grid-template-columns: .2fr .7fr 1fr .2fr;
  grid-template-rows: .5fr 1fr;
  grid-template-areas:
    "left-arrow correcoes-title conferencias-title right-arrow"
    "left-arrow correcoes conferencias right-arrow";

  .left-arrow {
    grid-area: left-arrow;
    place-self: center;
    transform: rotate(90deg);
    color: var(--color-primary);
  }
  .correcoes-title {
    grid-area: correcoes-title;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
  }
  .conferencias-title {
    grid-area: conferencias-title;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
  }
  .correcoes {
    grid-area: correcoes;
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "odd points";

    .odd-days, .incorrect-points {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .odd-days { grid-area: odd; }
    .incorrect-points { grid-area: points; }
  }
  .conferencias {
    grid-area: conferencias;
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
      "pendencies apontamentos events";

    .pendencies, .apontamentos, .events{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .pendencies { grid-area: pendencies }
    .apontamentos { grid-area: apontamentos }
    .events { grid-area: events }
  }
  .right-arrow {
    grid-area: right-arrow;
    place-self: center;
    transform: rotate(-90deg);
    color: var(--color-primary);
  }
}

.correcoes:after {
  content: '';
  width: 28%;
  border-bottom: solid 2px var(--color-primary);
  position: absolute;
  left: 36%;
  top: 25%;
}

.conferencias:after {
  content: '';
  width: 20%;
  border-bottom: solid 2px var(--color-primary);
  position: absolute;
  left: 23%;
  top: 25%;
}

.conferencias:before {
  content: '';
  width: 20%;
  border-bottom: solid 2px var(--color-primary);
  position: absolute;
  left: 57%;
  top: 25%;
}

.circle {
  height: 40px;
  width: 40px;
  font-size: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  position: relative;
}

.selected-color { background-color: var(--color-primary); color: white; }
.not-selected-color { background-color: lightgray; color: gray; }

[data-badge]:after {
  background: var(--color-danger);
  border-radius: 30px;
  color: #fff;
  content: attr(data-badge);
  font-size: 12px;
  margin-top: -10px;
  border: 2px solid var(--front-background-color);
  min-width: 13px;
  height: 14px;
  padding: 2px;
  position: absolute;
  text-align: center;
  top: 4px;
  left: 30px;
}

</style>
